/**
 * Intake UI helpers — shared formatting + availability helpers used by the
 * intake-aware landing components. Kept here so card, hero and section all
 * render dates / availability / CTAs consistently.
 */

const LOCALE = 'en-GB'

export function fmtDate(d) {
  if (!d) return null
  try {
    const date = new Date(d)
    if (isNaN(date.getTime())) return String(d).slice(0, 10)
    return date.toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' })
  } catch {
    return String(d).slice(0, 10)
  }
}

export function fmtDateLong(d) {
  if (!d) return null
  try {
    const date = new Date(d)
    if (isNaN(date.getTime())) return String(d).slice(0, 10)
    return date.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' })
  } catch {
    return String(d).slice(0, 10)
  }
}

/**
 * Map a program availability state to a consistent CTA descriptor so the
 * card, hero and section all agree on labels and actions.
 *
 *   open         → Apply now        (applyHref)
 *   closing-soon → Apply now        (applyHref) — with a "closing" hint
 *   upcoming     → Opens <date>     (detailHref)
 *   closed       → Join waitlist    (waitlistHref)
 *   fallback     → Enquire          (enquiryHref)
 */
export function ctaForProgram(program, enquiryHref = '/advisor') {
  switch (program.availability) {
    case 'open':
      return {
        label: 'Apply Now',
        href: program.applyHref,
        kind: 'primary',
      }
    case 'closing-soon':
      return {
        label: 'Apply Now',
        href: program.applyHref,
        kind: 'primary',
        hint: 'Closing soon',
      }
    case 'upcoming':
      return {
        label: program.registrationOpenDate
          ? `Opens ${fmtDate(program.registrationOpenDate)}`
          : program.startDate
            ? `Starts ${fmtDate(program.startDate)}`
            : 'View Dates',
        href: program.detailHref,
        kind: 'ghost',
      }
    case 'closed':
      return {
        label: 'Join Waitlist',
        href: program.waitlistHref || enquiryHref,
        kind: 'ghost',
      }
    default:
      return {
        label: 'Enquire',
        href: enquiryHref,
        kind: 'ghost',
      }
  }
}

export function availabilityMeta(program) {
  switch (program.availability) {
    case 'open':
      return { tone: 'green', label: 'Registration Open' }
    case 'closing-soon':
      return { tone: 'amber', label: 'Closing Soon' }
    case 'upcoming':
      return { tone: 'gold', label: 'Upcoming Intake' }
    case 'closed':
      return { tone: 'muted', label: 'Full · Waitlist Open' }
    default:
      return { tone: 'muted', label: 'Dates TBA' }
  }
}
